import { FormControl, Grid, InputLabel, TextField } from '@mui/material';
import { useAtom } from 'jotai';
import { useFormContext } from 'react-hook-form';

import { filteredLimaSourcesAtom } from '@/pages/Administration/Devices/Devices.store';

import useCloudSourceForm from '../../CloudSourceHooks/useCloudSourceForm.hooks';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import { WIZARD_STEP } from '../../SourceCreate.constants';
import {
  selectedSourceDetailsAtom,
  wizardCurrentStepAtom,
  wizardSelectedSourceAtom
} from '../../SourceCreate.store';
import { SourceDialogMode } from '../../SourceCreate.types';

/**
 * Renders the source type selector field (display only, not editable).
 *
 * Shows the selected source type name from either:
 * - Wizard mode: the wizardSelectedSource atom
 * - Edit mode: filteredLimaSources lookup by selected source uid
 */
export const SourceTypeSelector = () => {
  const { register, formState } = useFormContext();
  const { errors } = formState;

  const [currentStep] = useAtom(wizardCurrentStepAtom);
  const [wizardSelectedSource] = useAtom(wizardSelectedSourceAtom);
  const [selectedSourceDetails] = useAtom(selectedSourceDetailsAtom);

  const { mode, sourceTypeBasicData, selectedSourceTypeId } =
    useCloudSourceForm();
  const [filteredLimaSources] = useAtom(filteredLimaSourcesAtom);

  const isWizardMode =
    mode === SourceDialogMode.New &&
    currentStep === WIZARD_STEP.CONFIGURE_SOURCE;

  const srcTypeName = filteredLimaSources.find(
    (src) => src.source_uid === selectedSourceDetails?.source_uid
  )?.source_type?.name;

  return (
    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
      <InputLabel>
        Source <span> *</span>
      </InputLabel>
      <FormControl fullWidth>
        <input {...register('source_type_id')} type="hidden" />
        <TextField
          {...register('source_type_name')}
          name="source_type_name"
          disabled={true}
          value={
            isWizardMode && wizardSelectedSource
              ? wizardSelectedSource.product
              : srcTypeName ||
                sourceTypeBasicData?.find(
                  (item: { id: number; name: string }) =>
                    item.id === selectedSourceTypeId
                )?.name ||
                ''
          }
        />

        {errors.source_type_id && (
          <ErrorMessage message={errors.source_type_id?.message} />
        )}
      </FormControl>
    </Grid>
  );
};
